// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Button_btn__ksA\\+u {
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  column-gap: 8px;
  border-radius: 7px;
  cursor: pointer;
  transition: all 0.3s ease-out;
  position: relative;
  overflow: hidden;
}
.Button_ltrDir__vk3XL {
  direction: ltr !important;
}
.Button_smallWidth__pe6-0 {
  min-width: 50px;
}
.Button_largeWidth__IhJp- {
  min-width: 125px;
}
.Button_normalWidth__03bXu {
  min-width: 100px;
}
.Button_btn__ksA\\+u:after {
  background: #e2c8c8;
  content: "";
  height: 155px;
  left: -75px;
  opacity: 0.2;
  position: absolute;
  top: -50px;
  transform: rotate(35deg);
  transition: all 750ms cubic-bezier(0.19, 1, 0.22, 1);
  width: 50px;
  z-index: 0;
}

.Button_btn__ksA\\+u:hover:after {
  left: 120%;
  transition: all 750ms cubic-bezier(0.19, 1, 0.22, 1);
}

/* .btn:hover {
  transform: translateY(-1px);
  box-shadow: 0px 5px 11px 1px rgba(0, 0, 0, 0.2);
} */
.Button_contentContainer__jqFF7 {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  column-gap: 8px;
  padding-inline: 11px;
}
.Button_loading__Vjn0R {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
}
.Button_iconWrapper__qQBgq {
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  margin-inline-start: calc(-100% - 26px);
  opacity: 0;
  transition:
    margin-inline-start 0.3s ease-out,
    opacity 1.1s ease-out;
}
.Button_text__isQmV {
  transition: all 0.3s ease-out;
  font-size: var(--normal-text-size);
  font-weight: var(--normal-text-weight);
  display: flex;
  align-items: center;
  justify-content: center;
}
.Button_btn__ksA\\+u:hover .Button_iconWrapper__qQBgq {
  opacity: 1;
  margin-inline-start: calc(-100% + 32px);
}
.Button_btn__ksA\\+u:hover .Button_moveTextOnHover__GSsb7 {
  opacity: 1;
  padding-inline-start: 10px;
}
.Button_btn__ksA\\+u:hover .Button_largeMoveTextOnHover__vSmwo {
  opacity: 1;
  padding-inline-start: 20px;
}
.Button_confirmStyle__X5Eb2 {
  background-color: var(--focused-input-color);
  color: #fff;
}
.Button_rejectStyle__bIcf0 {
  background-color: var(--root-background-color);
  color: var(--invalid-input-color);
  border: 2px solid var(--invalid-input-color);
}
.Button_completeRejectStyle__CqqcS {
  background-color: var(--invalid-input-color);
  color: #fff;
}
.Button_commonStyle__mgtiX {
  border: 2px solid var(--focused-input-color);
  color: var(--focused-input-color);
  background-color: var(--root-background-color);
}
.Button_cancelStyle__6Abqm {
  background-color: #efefef;
  color: var(--enabled-input-label-color);
  border: 2px solid var(--disabled-input-label-color);
}
.Button_mounted__tAm\\+V {
  animation: Button_inAnimationx__hKNt- 250ms ease-in;
}
.Button_unmounted__ey6Tz {
  animation: Button_outAnimationx__NxmFA 270ms ease-out forwards;
}
@keyframes Button_inAnimationx__hKNt- {
  0% {
    opacity: 0;
    visibility: hidden;
    transform: translateX(50px);
  }
  100% {
    opacity: 1;
    visibility: visible;
  }
}
@keyframes Button_outAnimationx__NxmFA {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
    visibility: hidden;
    transform: rotate(180deg) scale(0.1);
  }
}
.Button_loadingMounted__Htgu- {
  animation: Button_inLoadingAnimationx__2\\+bAg 250ms ease-in;
}
.Button_loadingUnmounted__v2rmS {
  animation: Button_outLoadingAnimationx__X5pXA 270ms ease-out forwards;
}
@keyframes Button_inLoadingAnimationx__2\\+bAg {
  0% {
    opacity: 0;
    visibility: hidden;
    transform: rotate(180deg) scale(0.1);
  }
  100% {
    opacity: 1;
    visibility: visible;
  }
}

@keyframes Button_outLoadingAnimationx__X5pXA {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
    visibility: hidden;
    transform: rotate(180deg) scale(0.1);
  }
}
.Button_maxWidth__JALVv {
  width: 100%;
}
`, "",{"version":3,"sources":["webpack://./src/Components/UI/Button/Button.module.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,6BAA6B;EAC7B,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,eAAe;AACjB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,WAAW;EACX,aAAa;EACb,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,UAAU;EACV,wBAAwB;EACxB,oDAAoD;EACpD,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,oDAAoD;AACtD;;AAEA;;;GAGG;AACH;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,eAAe;EACf,oBAAoB;AACtB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;AACb;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,QAAQ;EACR,2BAA2B;EAC3B,uCAAuC;EACvC,UAAU;EACV;;yBAEuB;AACzB;AACA;EACE,6BAA6B;EAC7B,kCAAkC;EAClC,sCAAsC;EACtC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,UAAU;EACV,uCAAuC;AACzC;AACA;EACE,UAAU;EACV,0BAA0B;AAC5B;AACA;EACE,UAAU;EACV,0BAA0B;AAC5B;AACA;EACE,4CAA4C;EAC5C,WAAW;AACb;AACA;EACE,8CAA8C;EAC9C,iCAAiC;EACjC,4CAA4C;AAC9C;AACA;EACE,4CAA4C;EAC5C,WAAW;AACb;AACA;EACE,4CAA4C;EAC5C,iCAAiC;EACjC,8CAA8C;AAChD;AACA;EACE,yBAAyB;EACzB,uCAAuC;EACvC,mDAAmD;AACrD;AACA;EACE,mDAAqC;AACvC;AACA;EACE,8DAAgD;AAClD;AACA;EACE;IACE,UAAU;IACV,kBAAkB;IAClB,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,mBAAmB;EACrB;AACF;AACA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;IACV,kBAAkB;IAClB,oCAAoC;EACtC;AACF;AACA;EACE,2DAA4C;AAC9C;AACA;EACE,qEAAuD;AACzD;AACA;EACE;IACE,UAAU;IACV,kBAAkB;IAClB,oCAAoC;EACtC;EACA;IACE,UAAU;IACV,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;IACV,kBAAkB;IAClB,oCAAoC;EACtC;AACF;AACA;EACE,WAAW;AACb","sourcesContent":[".btn {\r\n  height: 40px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  column-gap: 8px;\r\n  border-radius: 7px;\r\n  cursor: pointer;\r\n  transition: all 0.3s ease-out;\r\n  position: relative;\r\n  overflow: hidden;\r\n}\r\n.ltrDir {\r\n  direction: ltr !important;\r\n}\r\n.smallWidth {\r\n  min-width: 50px;\r\n}\r\n.largeWidth {\r\n  min-width: 125px;\r\n}\r\n.normalWidth {\r\n  min-width: 100px;\r\n}\r\n.btn:after {\r\n  background: #e2c8c8;\r\n  content: \"\";\r\n  height: 155px;\r\n  left: -75px;\r\n  opacity: 0.2;\r\n  position: absolute;\r\n  top: -50px;\r\n  transform: rotate(35deg);\r\n  transition: all 750ms cubic-bezier(0.19, 1, 0.22, 1);\r\n  width: 50px;\r\n  z-index: 0;\r\n}\r\n\r\n.btn:hover:after {\r\n  left: 120%;\r\n  transition: all 750ms cubic-bezier(0.19, 1, 0.22, 1);\r\n}\r\n\r\n/* .btn:hover {\r\n  transform: translateY(-1px);\r\n  box-shadow: 0px 5px 11px 1px rgba(0, 0, 0, 0.2);\r\n} */\r\n.contentContainer {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  width: 100%;\r\n  column-gap: 8px;\r\n  padding-inline: 11px;\r\n}\r\n.loading {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  width: 100%;\r\n}\r\n.iconWrapper {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  position: absolute;\r\n  top: 50%;\r\n  transform: translateY(-50%);\r\n  margin-inline-start: calc(-100% - 26px);\r\n  opacity: 0;\r\n  transition:\r\n    margin-inline-start 0.3s ease-out,\r\n    opacity 1.1s ease-out;\r\n}\r\n.text {\r\n  transition: all 0.3s ease-out;\r\n  font-size: var(--normal-text-size);\r\n  font-weight: var(--normal-text-weight);\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n.btn:hover .iconWrapper {\r\n  opacity: 1;\r\n  margin-inline-start: calc(-100% + 32px);\r\n}\r\n.btn:hover .moveTextOnHover {\r\n  opacity: 1;\r\n  padding-inline-start: 10px;\r\n}\r\n.btn:hover .largeMoveTextOnHover {\r\n  opacity: 1;\r\n  padding-inline-start: 20px;\r\n}\r\n.confirmStyle {\r\n  background-color: var(--focused-input-color);\r\n  color: #fff;\r\n}\r\n.rejectStyle {\r\n  background-color: var(--root-background-color);\r\n  color: var(--invalid-input-color);\r\n  border: 2px solid var(--invalid-input-color);\r\n}\r\n.completeRejectStyle {\r\n  background-color: var(--invalid-input-color);\r\n  color: #fff;\r\n}\r\n.commonStyle {\r\n  border: 2px solid var(--focused-input-color);\r\n  color: var(--focused-input-color);\r\n  background-color: var(--root-background-color);\r\n}\r\n.cancelStyle {\r\n  background-color: #efefef;\r\n  color: var(--enabled-input-label-color);\r\n  border: 2px solid var(--disabled-input-label-color);\r\n}\r\n.mounted {\r\n  animation: inAnimationx 250ms ease-in;\r\n}\r\n.unmounted {\r\n  animation: outAnimationx 270ms ease-out forwards;\r\n}\r\n@keyframes inAnimationx {\r\n  0% {\r\n    opacity: 0;\r\n    visibility: hidden;\r\n    transform: translateX(50px);\r\n  }\r\n  100% {\r\n    opacity: 1;\r\n    visibility: visible;\r\n  }\r\n}\r\n@keyframes outAnimationx {\r\n  0% {\r\n    opacity: 1;\r\n  }\r\n  100% {\r\n    opacity: 0;\r\n    visibility: hidden;\r\n    transform: rotate(180deg) scale(0.1);\r\n  }\r\n}\r\n.loadingMounted {\r\n  animation: inLoadingAnimationx 250ms ease-in;\r\n}\r\n.loadingUnmounted {\r\n  animation: outLoadingAnimationx 270ms ease-out forwards;\r\n}\r\n@keyframes inLoadingAnimationx {\r\n  0% {\r\n    opacity: 0;\r\n    visibility: hidden;\r\n    transform: rotate(180deg) scale(0.1);\r\n  }\r\n  100% {\r\n    opacity: 1;\r\n    visibility: visible;\r\n  }\r\n}\r\n\r\n@keyframes outLoadingAnimationx {\r\n  0% {\r\n    opacity: 1;\r\n  }\r\n  100% {\r\n    opacity: 0;\r\n    visibility: hidden;\r\n    transform: rotate(180deg) scale(0.1);\r\n  }\r\n}\r\n.maxWidth {\r\n  width: 100%;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"btn": `Button_btn__ksA+u`,
	"ltrDir": `Button_ltrDir__vk3XL`,
	"smallWidth": `Button_smallWidth__pe6-0`,
	"largeWidth": `Button_largeWidth__IhJp-`,
	"normalWidth": `Button_normalWidth__03bXu`,
	"contentContainer": `Button_contentContainer__jqFF7`,
	"loading": `Button_loading__Vjn0R`,
	"iconWrapper": `Button_iconWrapper__qQBgq`,
	"text": `Button_text__isQmV`,
	"moveTextOnHover": `Button_moveTextOnHover__GSsb7`,
	"largeMoveTextOnHover": `Button_largeMoveTextOnHover__vSmwo`,
	"confirmStyle": `Button_confirmStyle__X5Eb2`,
	"rejectStyle": `Button_rejectStyle__bIcf0`,
	"completeRejectStyle": `Button_completeRejectStyle__CqqcS`,
	"commonStyle": `Button_commonStyle__mgtiX`,
	"cancelStyle": `Button_cancelStyle__6Abqm`,
	"mounted": `Button_mounted__tAm+V`,
	"inAnimationx": `Button_inAnimationx__hKNt-`,
	"unmounted": `Button_unmounted__ey6Tz`,
	"outAnimationx": `Button_outAnimationx__NxmFA`,
	"loadingMounted": `Button_loadingMounted__Htgu-`,
	"inLoadingAnimationx": `Button_inLoadingAnimationx__2+bAg`,
	"loadingUnmounted": `Button_loadingUnmounted__v2rmS`,
	"outLoadingAnimationx": `Button_outLoadingAnimationx__X5pXA`,
	"maxWidth": `Button_maxWidth__JALVv`
};
export default ___CSS_LOADER_EXPORT___;
